import { render, staticRenderFns } from "./rtcf.vue?vue&type=template&id=690a2168&scoped=true"
import script from "./rtcf.vue?vue&type=script&lang=js"
export * from "./rtcf.vue?vue&type=script&lang=js"
import style0 from "./rtcf.vue?vue&type=style&index=0&id=690a2168&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a2168",
  null
  
)

export default component.exports